<template>
  <div>
    <div class="col-md-12 outside">
      <div class="mystyle">
        <div class="row">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12 fontSize16">
              呼號/隊呼:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">{{ callNumber }}</div>
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12 fontSize16">
              姓名:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">{{ name }}</div>
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <select
              v-model="listValue"
              id="select"
              class="form-control fontSize16"
              @change="changeTableData(listValue)"
            >
              <option :value="-1" SELECTED>繳費單</option>
              <option v-for="pay in paymentList" :value="pay.id">
                {{ pay.timeBegin }}~{{ pay.timeUntil }} 每個月須付${{
                  pay.serviceFee
                }}， 基本每班費${{ pay.feePerShift }}, 限定{{
                  pay.shiftLimit
                }}班,超過限定班數， 每班車資為${{ pay.feePerOverShiftLimit }},
                乘客險月費${{ pay.insuranceForUser }}, 車資比例{{
                  pay.fareCommission
                }}％
              </option>
            </select>
          </div>
        </div>
        <div class="row margin_top" v-show="btnvisible">
          <div class="margin_top">
            <div class="col-md-12">
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">服務費:</div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">{{ paymentInfo.service_fee }}元</div>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <button
                  class="btn"
                  v-if="btnservicevisible"
                  :class="{
                    'btn-success': !non_service_click,
                    'btn-danger': non_service_click,
                  }"
                  @click="showServiceToggle"
                >
                  {{ service_message }}
                </button>
                <div class="fontSize16" v-else>
                  {{ paymentInfo.time_service }}已繳費
                </div>
              </div>
            </div>
          </div>
          <div class="margin_top">
            <div class="col-md-12">
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">出班費:</div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">{{ paymentInfo.shift_fee }}元</div>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <button
                  class="btn"
                  v-if="btnshiftvisible"
                  :class="{
                    'btn-success': !non_shift_fee_click,
                    'btn-danger': non_shift_fee_click,
                  }"
                  @click="showShiftToggle"
                >
                  {{ shift_fee_message }}
                </button>
                <div class="fontSize16" v-else>
                  {{ paymentInfo.time_shift }}已繳費
                </div>
              </div>
            </div>
          </div>
          <div class="margin_top">
            <div class="col-md-12">
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">乘客險費用:</div>
              </div>
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div class="fontSize16">{{ paymentInfo.insurance_fee }}元</div>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <button
                  class="btn"
                  v-if="btninsurancevisible"
                  :class="{
                    'btn-success': !non_insurance_fee_click,
                    'btn-danger': non_insurance_fee_click,
                  }"
                  @click="showInsuranceeToggle"
                >
                  {{ insurance_fee_message }}
                </button>
                <div class="fontSize16" v-else>
                  {{ paymentInfo.time_insurance }}已繳費
                </div>
              </div>
            </div>
          </div>
          <div class="margin_top">
            <div class="col-md-12">
              <div class="col-md-3 col-sm-12 col-xs-12">
                <div class="fontSize16">總計:</div>
              </div>
              <div class="col-md-2 col-sm-12 col-xs-12">
                <div class="fontSize16">{{ this.paymentInfo.total }}元</div>
              </div>
            </div>
          </div>
          <button
            @click="savePayment"
            class="btn btn-dark item-btn"
            type="button"
            name="button"
          >
            繳費儲存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['name', 'callNumber', 'paymentList', 'initial'],
  data() {
    return {
      paymentInfo: {
        payment_id: null,
        service_fee: null,
        insurance_fee: null,
        shiftFee: null,
        total: null,
        has_service_fee: false,
        has_insurance: false,
        time_service: null,
        time_shift: null,
        time_insurance: null,
      },
      payment_status: {
        id: null,
        is_service: null,
        is_shift_fee: null,
        is_insurance_fee: null,
        shift_fee: null,
      },
      non_service_click: true,
      non_shift_fee_click: true,
      non_insurance_fee_click: true,
      service_message: '繳費',
      shift_fee_message: '繳費',
      insurance_fee_message: '繳費',
      listValue: -1,
      btnvisible: false,
      btnservicevisible: true,
      btnshiftvisible: true,
      btninsurancevisible: true,
    }
  },
  methods: {
    initialPaymentForm(initial) {
      if (initial) {
        this.btnvisible = false
        this.paymentInfo.payment_id = null
        this.paymentInfo.service_fee = null
        this.paymentInfo.insurance_fee = null
        this.paymentInfo.shift_fee = null
        this.paymentInfo.total = null
        this.non_service_click = true
        this.non_shift_fee_click = true
        this.non_insurance_fee_click = true
        this.service_message = '繳費'
        this.shift_fee_message = '繳費'
        this.insurance_fee_message = '繳費'
        this.listValue = -1
      }
    },
    showServiceToggle() {
      this.non_service_click = !this.non_service_click
      if (this.non_service_click) {
        this.service_message = '繳費'
      } else {
        this.service_message = '已繳費'
      }
      this.payment_status.is_service = !this.non_service_click
    },
    showShiftToggle() {
      let currentTime = moment().format('YYYY-MM-DD')
      if (
        moment(currentTime).isBefore(this.paymentInfo.timeUntil) &&
        this.non_shift_fee_click
      ) {
        if (!confirm('繳費單時間還沒到，出班費未統計完，確定要送出？')) return
      }
      this.non_shift_fee_click = !this.non_shift_fee_click
      if (this.non_shift_fee_click) {
        this.shift_fee_message = '繳費'
      } else {
        this.shift_fee_message = '已繳費'
      }
      this.payment_status.shift_fee = this.paymentInfo.shift_fee
      this.payment_status.is_shift_fee = !this.non_shift_fee_click
    },
    showInsuranceeToggle() {
      this.non_insurance_fee_click = !this.non_insurance_fee_click
      if (this.non_insurance_fee_click) {
        this.insurance_fee_message = '繳費'
      } else {
        this.insurance_fee_message = '已繳費'
      }
      this.payment_status.is_insurance_fee = !this.non_insurance_fee_click
    },
    changeTableData(value) {
      // console.log(this.paymentList.length)
      // if(value)
      if (document.getElementById('select').value === 'payment') {
        this.non_service_click = true
        this.non_shift_fee_click = true
        this.non_insurance_fee_click = true
        this.btnvisible = false
      } else {
        this.btnvisible = true
        this.btnservicevisible = true
        this.btnshiftvisible = true
        this.btninsurancevisible = true
        for (var i = 0; i < this.paymentList.length; i++) {
          if (this.paymentList[i].id === this.listValue) {
            this.paymentInfo.insurance_fee =
              this.paymentList[i].insuranceForUser
            this.paymentInfo.service_fee = this.paymentList[i].serviceFee
            this.paymentInfo.shift_fee = this.paymentList[i].shiftFee
            this.paymentInfo.time_service = this.paymentList[i].timeService
            this.paymentInfo.time_shift = this.paymentList[i].timeShift
            this.paymentInfo.time_insurance = this.paymentList[i].timeInsurance
            this.payment_status.id = this.paymentList[i].id

            if (this.paymentList[i].isServiceFeePaid) {
              this.btnservicevisible = false
              this.payment_status.is_service = null
            }
            if (this.paymentList[i].isShiftFeePaid) {
              this.btnshiftvisible = false
              this.payment_status.is_shift_fee = null
            }
            if (this.paymentList[i].isInsurancePaid) {
              this.btninsurancevisible = false
              this.payment_status.is_insurance_fee = null
            }
          }
        }
        this.paymentInfo.total =
          this.paymentInfo.insurance_fee + this.paymentInfo.service_fee
      }
    },
    savePayment() {
      // console.log(this.payment_status)
      this.$emit('save-payment', this.payment_status)
    },
  },
  mounted() {},
}
</script>

<style scoped>
.margin_top {
  margin-top: 20px;
}
.item-btn {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/PayForm.vue